"use strict";
var ɵngcc0 = require('@angular/core');
var ɵngcc1 = require('./ng2-order.pipe');
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
/**
 * Created by vadimdez on 20/01/2017.
 */
var core_1 = require("@angular/core");
var ng2_order_pipe_1 = require("./ng2-order.pipe");
var Ng2OrderModule = (function () {
    function Ng2OrderModule() {
    }
Ng2OrderModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: Ng2OrderModule });
Ng2OrderModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function Ng2OrderModule_Factory(t) { return new (t || Ng2OrderModule)(); } });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(Ng2OrderModule, { declarations: [ɵngcc1.Ng2OrderPipe], exports: [ɵngcc1.Ng2OrderPipe] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(Ng2OrderModule, [{
        type: core_1.NgModule,
        args: [{
                declarations: [ng2_order_pipe_1.Ng2OrderPipe],
                exports: [ng2_order_pipe_1.Ng2OrderPipe]
            }]
    }], function () { return []; }, null); })();
    return Ng2OrderModule;
}());
exports.Ng2OrderModule = Ng2OrderModule;

//# sourceMappingURL=ng2-order.module.js.map